/**
 * O lens depende de backdrop-filter aceitando url(#filtro).
 * Chromium aceita; Safari e Firefox não — lá o nível cai para frost.
 * Ver Docs/04-Design/Liquid Glass.md.
 */
export function supportsLens(): boolean {
  if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false
  if (typeof matchMedia === 'function' && matchMedia('(prefers-reduced-transparency: reduce)').matches) {
    return false
  }
  return (
    CSS.supports('backdrop-filter', 'url(#porquinho-lens)') ||
    CSS.supports('-webkit-backdrop-filter', 'url(#porquinho-lens)')
  )
}
